import { PatientEhrQuery } from "@/lib/layout/types";

/** A chart URL param that opens one record in the Records tab, and the tab data key it fills. */
export interface RecordsDeepLinkParam {
  param: string;
  dataKey: string;
}

// Order is precedence when a URL carries more than one record param.
export const RECORDS_DEEP_LINK_PARAMS: RecordsDeepLinkParam[] = [
  { param: PatientEhrQuery.scribeId, dataKey: "scribeId" },
  { param: PatientEhrQuery.formId, dataKey: "questionnaireResponseId" },
  { param: PatientEhrQuery.labId, dataKey: "labResultId" },
  { param: PatientEhrQuery.documentId, dataKey: "documentId" },
];

/**
 * The practice-relative patient chart URL. `query` keys are `PatientEhrQuery` values, e.g.
 * `{ tab: "Records", labId: "…" }`.
 */
export function buildPatientChartHref({
  practiceSlug,
  patientId,
  query,
}: {
  practiceSlug: string;
  patientId: string;
  query?: Record<string, string>;
}): string {
  const chartPath = `/${practiceSlug}/patients/${patientId}`;
  const search = new URLSearchParams(query).toString();
  return search ? `${chartPath}?${search}` : chartPath;
}
